import { LangTranslate } from "../../types/types";

export type UpdateTranslationsRequest = {
   key:string,
   translationsList:LangTranslate[]
     TypeSite:string;
     isAdmin:string
  };
export function createUpdateTranslationsRequest(
  key: string,
  translationsList: LangTranslate[],
  isAdmin:string,
  TypeSite: string = "admin"
): UpdateTranslationsRequest {
  return { key, translationsList, TypeSite ,isAdmin};
}